// ============================================
// MEDFLOW - Auth Configuration
// ============================================

export const authMode = 'legacy';

export const isSupabaseAuthEnabled = false;
